function getSerialFromTopic(value) {
  const topic = value[Object.getOwnPropertySymbols(value)[0]];
  const emiString = topic.split('/')[2];
  return emiString.split('_')[1];
}
export default getSerialFromTopic;
